export const pages = {
  home: {
    url: '/',
    text: 'Home',
    exact: true,
  },
  about: {
    url: '/about',
    text: 'About Us',
  },
  history: {
    url: '/about/history',
    text: 'History',
    parent: 'about',
  },
  hseq: {
    url: '/about/hseq',
    text: 'HSEQ',
    parent: 'about',
  },
  managementTeam: {
    url: '/about/management-team',
    text: 'Management Team',
    parent: 'about',
  },
  termsAndConditions: {
    url: '/legal/terms-and-conditions',
    text: 'General Terms & Conditions',
    parent: 'legal',
  },
  csr: {
    url: '/about/csr',
    text: 'Corporate Social Responsibility',
    about: 'about',
  },
  careers: {
    url: '/careers',
    text: 'Careers',
  },
  contact: {
    url: '/contact',
    text: 'Contact Us',
  },
  jobs: {
    url: '/careers/jobs',
    text: 'Job Openings',
    parent: 'careers',
  },
  initiativeApplication: {
    url: '/careers/jobs/open',
    text: 'Initiative Application',
    parent: 'jobs',
  },
  construction: {
    id: 'construction',
    url: '/companies/construction',
    text: 'CEAD Construction N.V.',
  },
  manpower: {
    id: 'manpower',
    url: '/companies/manpower',
    text: 'CEAD Manpower N.V.',
  },
  engineering: {
    id: 'engineering',
    url: '/companies/engineering',
    text: 'CEAD Engineering N.V.',
  },
  engineeringAndDesign: {
    url: '/companies/engineering/engineering-and-design',
    text: 'Engineering & Design',
    parent: 'engineering',
  },
  industrialProductSales: {
    url: '/companies/engineering/industrial-product-sales',
    text: 'Industrial Product Sales',
    parent: 'engineering',
  },
};
